
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div v-if="notification">
    <b-card
            class="card-collapse border-raduis-xl border-0 my-4 p-2 bg-yellow-light"
    >
      <div class="title">
        <h2 class="mb-0 pr-5">
          <span class="badge-icon mr-2 fsize-3">
            <em class="icomoon icon-bell"></em>
          </span>
          <span :class="{'text-primary': !noTitlePrimary}">{{ $t('notifications') }}</span>
        </h2>
        <div v-if="!noButton" class="btn-collapse" v-b-toggle="id">
          <b-icon icon="chevron-up" class="fsize-2"></b-icon>
        </div>
      </div>
      <b-collapse :id="id" :visible="visible">
        <div
                class="notification mt-4 font-weight-light"
                v-for="(data, index) in notification"
                :key="index"
        >
          <span>{{ moment(data.creationDate, 'x').format('DD/MM/YYYY - HH:mm') }} : </span>
          <span v-html="data.callToAction
                  ? data.type === 'CALL_TO_ACTION_1'
                    ? `Demande d'intervention`
                    : `Demande de chargement d’un document`
                  : data.content"> </span>
          <div class="content ml-4 pl-2 mt-2">
            <template v-if="!data.callToAction">
              <span class="mr-2">Ancien statut :</span>
              <b-badge :variant="(badgeVariant)? badgeVariant: 'primary'" pill class="py-2 px-4 mr-2">
                {{ data.entity === 'LOT' ?
                $t('lot_status.' + data.oldStatus)
                : data.entity === 'OPERATION' ?
                $t('operation_status.' + data.oldStatus)
                : $t(data.oldStatus)
                }}
              </b-badge>
              <b-icon icon="arrow-right" class="fsize-3 mr-2"></b-icon>
              <span class="mr-2">Nouveau statut :</span>
              <b-badge :variant="(badgeVariant)? badgeVariant: 'primary'" pill class="py-2 px-4">
                {{ data.entity === 'LOT' ?
                $t('lot_status.' + data.newStatus)
                : data.entity === 'OPERATION' ?
                $t('operation_status.' + data.newStatus)
                : $t(data.newStatus)
                }}
              </b-badge>
            </template>
            <template v-else>
              <span v-html="data.content"> </span>
            </template>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'CollapseGroupedNotifications',
    props: ['id', 'visible', 'noButton','notification','noTitlePrimary','badgeVariant'],
  };
</script>
